import {createAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {signalAssetEvents, signalEvents} from "../../services/apiService";

export const signalsSlice = createSlice({
    name: 'strategySignals',
    initialState: {
        loading : false,
        signalEvents: [],
        pagination : {
            showSizeChanger:false,
            total: 0,
            pageSize: 20,
            current: 1
        },
        tableFilters: undefined,
        filters: undefined,
        selectedStrategies: [],
        signalAssetEvents: {},
        loadingSignalAssetEvents: {}
    },
    reducers: {
        updatePagination: (state, action) => {
            state.pagination = { ...state.pagination, ...action.payload };
        },
        updateSelectedStrategies: (state, action) => {
            state.selectedStrategies = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadStrategySignalEvents.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(loadStrategySignalEvents.fulfilled, (state, action) => {
                const {content: strategies = [], pageable: page, totalElements} = action.payload;
                const pagination = {
                    total: totalElements,
                    pageSize: page.pageSize,
                    current: page.pageNumber + 1
                };
                state.signalEvents = strategies;
                state.pagination = pagination;
                state.loading = false;
            })
            .addCase(loadStrategySignalEvents.rejected, (state, action) => {
                state.signalEvents = [];
                state.loading = false;
            })
            .addCase(loadSignalAssetEvents.pending, (state, action) => {
                const signalEventId = action.meta.arg;
                state.loadingSignalAssetEvents = {
                    ...state.loadingSignalAssetEvents,
                    [signalEventId]: true
                };
            })
            .addCase(loadSignalAssetEvents.fulfilled, (state, action) => {
                const { signalEventId, signalAssetEvents } = action.payload;
                state.signalAssetEvents = {
                    ...state.signalAssetEvents,
                    [signalEventId]: signalAssetEvents
                };
                state.loadingSignalAssetEvents = {
                    ...state.loadingSignalAssetEvents,
                    [signalEventId]: false
                }
            })
            .addCase(loadSignalAssetEvents.rejected, (state, action) => {
                const signalEventId = action.meta.arg;
                state.loadingSignalAssetEvents = {
                    ...state.loadingSignalAssetEvents,
                    [signalEventId]: false
                };
            });
    }
})

export const loadStrategySignalEvents = createAsyncThunk('strategySignals/loadStrategySignalEvents', ({pagination, selectedStrategies}) => {
    return signalEvents(pagination, selectedStrategies);
})

export const loadSignalAssetEvents = createAsyncThunk( 'strategySignals/loadSignalAssetEvents', async (signalEventId, { rejectWithValue }) => {
    try {
        const result = await signalAssetEvents(signalEventId);
        return { signalEventId, signalAssetEvents: result };
    } catch (error) {
        return rejectWithValue(error.result);
    }
});

// Экспортируем синхронные actions
export const { updatePagination, updateSelectedStrategies,
    setLoadingSignalAssetEvent, setSignalAssetEvent} = signalsSlice.actions;

export default signalsSlice.reducer

